export default {
    setDomainLinkage (state,value) {
        state.campaignLanguages = value.campaignLanguages;
        state.appDownloadUrl = value.appDownloadUrl;
    }
}